import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMeApi, getPurchasesApi } from '../utils/api';

const S = process.env.REACT_APP_API_URL?.replace('/api','') || '';

export default function Dashboard() {
  const { user } = useAuth();
  const [profile,   setProfile]   = useState(null);
  const [purchases, setPurchases] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    Promise.all([getMeApi(), getPurchasesApi()])
      .then(([m, p]) => { setProfile(m.data); setPurchases(p.data); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="spinner" style={{marginTop:120}} />;
  const owned = profile?.purchasedBooks || [];

  return (
    <div style={{minHeight:'80vh'}}>
      <div style={{ background:'linear-gradient(135deg,var(--bg2),var(--bg))', borderBottom:'1px solid var(--border)', padding:'48px 0 40px' }}>
        <div className="container">
          <h1 style={{ fontFamily:'var(--font-d)', fontSize:'2.6rem', fontWeight:600, color:'var(--text)', marginBottom:6 }}>My Library</h1>
          <p style={{ color:'var(--text3)' }}>Welcome back, {user?.name}</p>
        </div>
      </div>

      <div className="container" style={{ padding:'40px 24px 80px' }}>
        {/* Stats */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))', gap:16, marginBottom:48 }}>
          {[['📚',owned.length,'Books Owned'],['🛒',purchases.length,'Purchases'],['💰',`₹${purchases.reduce((s,p)=>s+p.amount,0)}`, 'Total Spent']].map(([icon,val,label])=>(
            <div key={label} style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px', display:'flex', gap:16, alignItems:'center' }}>
              <span style={{fontSize:'2rem'}}>{icon}</span>
              <div>
                <div style={{ fontFamily:'var(--font-d)', fontSize:'1.8rem', fontWeight:700, color:'var(--text)', lineHeight:1 }}>{val}</div>
                <div style={{ color:'var(--text3)', fontSize:'0.78rem', marginTop:4, textTransform:'uppercase', letterSpacing:'0.06em', fontWeight:700 }}>{label}</div>
              </div>
            </div>
          ))}
        </div>

        <h2 style={{ fontFamily:'var(--font-d)', fontSize:'1.8rem', color:'var(--text)', marginBottom:24 }}>Owned Books</h2>
        {owned.length === 0 ? (
          <div style={{ textAlign:'center', padding:'48px', background:'var(--surface)', borderRadius:'var(--radius-lg)', border:'1px solid var(--border)', color:'var(--text3)' }}>
            <p style={{fontSize:'2.5rem',marginBottom:12}}>📭</p>
            <p>No books yet.</p>
            <Link to="/books" className="btn btn-gold btn-sm" style={{marginTop:16}}>Browse Library</Link>
          </div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))', gap:20, marginBottom:48 }}>
            {owned.map(book => {
              const cover = book.coverImage ? (book.coverImage.startsWith('http') ? book.coverImage : `${S}${book.coverImage}`) : null;
              return (
                <Link key={book._id} to={`/books/${book._id}`} style={{textDecoration:'none'}}>
                  <div className="card">
                    {cover ? <img src={cover} alt={book.title} style={{width:'100%',aspectRatio:'2/3',objectFit:'cover',display:'block'}} />
                      : <div style={{aspectRatio:'2/3',background:'linear-gradient(135deg,var(--bg3),#3d2060)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'2.5rem'}}>📚</div>
                    }
                    <div style={{padding:'12px'}}>
                      <p style={{fontWeight:700,color:'var(--text)',fontSize:'0.88rem',lineHeight:1.3}}>{book.title}</p>
                      <span className="badge badge-free" style={{marginTop:6}}>Owned</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}

        {purchases.length > 0 && (
          <>
            <h2 style={{ fontFamily:'var(--font-d)', fontSize:'1.8rem', color:'var(--text)', marginBottom:20 }}>Purchase History</h2>
            <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', overflow:'hidden' }}>
              {purchases.map((p,i) => (
                <div key={p._id} style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr', gap:16, padding:'16px 24px', borderBottom: i<purchases.length-1 ? '1px solid var(--border)' : 'none', alignItems:'center' }}>
                  <span style={{fontWeight:700,color:'var(--text)',fontSize:'0.9rem'}}>{p.book?.title || p.chapter?.title || '—'}</span>
                  <span className={`badge badge-${p.purchaseType==='book'?'gold':'amber'}`}>{p.purchaseType}</span>
                  <span style={{fontWeight:700,color:'var(--gold)'}}>₹{p.amount}</span>
                  <span style={{color:'var(--text3)',fontSize:'0.82rem'}}>{new Date(p.createdAt).toLocaleDateString()}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
